import { lazy, Suspense } from 'react';
import { AuthComponentProps } from './LazyAuthView.types';

const LazyAuthView = lazy(() => import('./LazyAuthView'));

export const AuthView = (props: AuthComponentProps) => {
  return (
    <Suspense fallback={<></>}>
      <LazyAuthView {...props} />
    </Suspense>
  );
};
